import React from 'react';
import PropTypes from 'prop-types';
import {Chip} from 'views/components';
import contrast from 'css/Contrast';
import {translate} from 'views/module';

const ClientLeadStatusView = (props) => {
  const {
    clientLeadData,
    setIsEditing,
  } = props;

  const status = clientLeadData.status;

  const title = translate(`clientLead.Status.${status}.Title`);
  const color = translate(`clientLead.Status.${status}.Color`);
  const textColor = contrast(color);

  return (
    <Chip
      label={title}
      sx={{
        backgroundColor: color,
        color: textColor,
        cursor: 'pointer',
      }}
      onClick={() => setIsEditing(true)}
    />
  );
};

ClientLeadStatusView.propTypes = {
  clientLeadData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(ClientLeadStatusView);
